import { render, staticRenderFns } from "./IconSvgTwitter.vue?vue&type=template&id=eb91775a&scoped=true&"
import script from "./IconSvgTwitter.vue?vue&type=script&lang=js&"
export * from "./IconSvgTwitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb91775a",
  null
  
)

export default component.exports